/* tslint:disable */

/**
 */
export class ViewCurve {
    ID_EQUIP?: number;
    isCapabilities?: number;
    REGUL_TEMP?: number;
    DWELLING_TIME?: number;
    PRODTEMP?: number;
    LOADINGRATE?: number;
    FAN_FREQUENCY?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-curve.ts